module.exports = __webpack_public_path__ + "img/product.fb29c6fd.png";